// @flow
import React, { createContext, useContext, useState, useEffect } from 'react';
import type { Node } from 'react';
import Debug from 'debug';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { ZINDEX } from '../../../../constants/appConstants';
import { useMap } from '../../../ui/openlayers';
import type { Layer } from '../../../ui/openlayers';
import style from './style';

const debug = Debug('amms:modules:map:trails');

type Context = $ReadOnly<{
    layer: ?Layer
}>;

const TrailsContext = createContext<Context>({});

type Props = $ReadOnly<{
    children: Node
}>;

export const TrailsProvider = ({ children }: Props) => {
    const map = useMap();
    const [layer] = useState(new VectorLayer({
        source: new VectorSource(),
        style: style,
        zIndex: ZINDEX.trails
    }));

    useEffect(() => {
        if(map) {
            debug(`Adding trails layer`);
            map.addLayer(layer);
        }

        return () => {
            if(map) {
                debug(`Removing trails layer`);

                map.removeLayer(layer);
            }
        };
    }, [map, layer]);

    const context = {
        layer
    };

    return (
        <TrailsContext.Provider value={context}>
            {children}
        </TrailsContext.Provider>
    );
};

const useTrailsContext = () => useContext(TrailsContext);

export const useTrailsLayer = () => {
    const context = useTrailsContext();
    return context.layer;
};